import React from 'react';

export default function ProductView({ id, isCompared, error, labels, onChange }) {
    return (
        <div className={error ? "product-compare has-error" : "product-compare"}>
            <div className="checkbox">
                <input id={id} type="checkbox" checked={isCompared} onChange={onChange} />
                <label htmlFor={id} className="form-label">{labels.label}</label>
            </div>
            {error ? (<div className="error-message">{error}</div>) : null}
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductCompare/Views/ProductView.jsx